<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/xPTpHc/tc-custom/9781473820562.jpg?1725723409307" alt="This image is the cover for the book Waterloo 1815: Quatre Bras & Ligny"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Waterloo 1815: Quatre Bras & Ligny
      </h1>
      <p class="bookDescription body article font2">
        <p>The Battle of Waterloo marked the climax of four extraordinary months. Napoleon returned from exile, ousted the unpopular King Louis XVIII, and then turned to launch a pre-emptive strike against the Allied armies assembling in the United Netherlands. Here Napoleon met Wellington who had cobbled together an army with contingents from the British, the United Netherlands and the Prussians, firstly at Quatre Bras and then finally at Waterloo.This is the second book in the series to cover the battle following on from Hougoumont.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Peter Hofschröer
      </h2>
      
      <p class="authorDescription body article">Peter Hofschroer is one of the leading authorities on the Napoleonic Wars. He has made a special study of the role of the German forces and of the Battle of Waterloo. His best-known work is 1815 - The Waterloo Campaign, a ground-breaking re-examination of the culminating event of the Napoleonic era.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen & Sword
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?79300bc1